export function storagetGet(dataName: any) {
  return localStorage.getItem(dataName);
}

export function storagetSet(name: string, data: any) {
  return localStorage.setItem(name, data);
}
